<nb-card>
    <nb-card-header class="card-header">
      <span>Top devices</span>
  
      <div class="header-controls">
        <nb-select
          [selected]="selectedRanking$ | async"
          (selectedChange)="onRankingChange($event)">
          <nb-option *ngFor="let o of rankingOptions" [value]="o.value">
            {{ o.label }}
          </nb-option>
        </nb-select>
  
        <button
          nbButton
          ghost
          shape="round"
          status="basic"
          [nbTooltip]="showChart ? 'Switch to table' : 'Switch to chart'"
          (click)="toggleView()"
          aria-label="Toggle chart / table view">
          <nb-icon [icon]="showChart ? 'grid-outline' : 'bar-chart-outline'"></nb-icon>
        </button>
      </div>
    </nb-card-header>
  
    <ng-container *ngIf="statistics$ | async as statistics; else loading">
  
      <nb-card-body *ngIf="!showChart" class="table-container">
        <app-top-devices-table [statistics]="statistics"></app-top-devices-table>
      </nb-card-body>
  
      <nb-card-body *ngIf="showChart">
        <app-top-devices-chart
          [statistics]="statistics"
          [ranking]="selectedRanking$ | async">
        </app-top-devices-chart>
      </nb-card-body>
  
    </ng-container>
  </nb-card>
  
  <ng-template #loading>
    <div class="spinner" [nbSpinner]="true" nbSpinnerSize="large"></div>
  </ng-template>